import classNames from "classnames/bind"
import style from './index.module.scss'
import { useTranslation } from "react-i18next"
import { Button, Col, Form, Row, Select, Space, Tooltip, notification } from "antd"
import { useEffect, useMemo, useState } from "react"
import { getUser } from "utils/index"
import shopApi from "api/shop"
import moment from "moment"
import { InventoryFilter, InventoryTable } from "./components"
import holidayApi from "api/holiday"
import inventoryApi from "api/inventory"
import ModalMonthlyExport from "./components/ModalMonthlyExport"
import { rolesExportMonthly, rolesGetAllShop } from "./roles"

const cx = classNames.bind(style)
export default function InventoryPage() {
    const [formSearch] = Form.useForm()
    const { t } = useTranslation()
    const [api, contextHolder] = notification.useNotification();

    const [shops, setShops] = useState([])
    const [loading, setLoading] = useState(false)
    const [inventoryInfo, setInventoryInfo] = useState(null)
    const [listHoliday, setListHoliday] = useState([])

    const openNotificationWithIcon = (type, message, description) => {
        api[type]({ message, description });
    };

    const shopInfo = useMemo(() => {
        return shops.find((shop) => shop.value === formSearch.getFieldValue('shop'))
    }, [formSearch, shops])

    const getStore = async () => {
        try {
            const res = await shopApi.getShopByRole();
            if (rolesGetAllShop.includes(+getUser().role)) {
                setShops(
                    res.shops.map((shop) => ({
                        value: shop.shopId,
                        label: shop.shopName,
                        cabinet_code_1: shop.cabinet_code_1,
                        cabinet_code_2: shop.cabinet_code_2,
                    }))
                );
            } else {
                setShops(
                    res.shops.map((shop) => ({
                        value: shop.shop._id,
                        label: shop.shop.name,
                        cabinet_code_1: shop.shop.cabinet_code_1,
                        cabinet_code_2: shop.shop.cabinet_code_2,
                    }))
                );
                formSearch.setFieldsValue({
                    shop: res.shops[0].shop._id
                });
            }
        } catch (error) {

        }
    };

    const onSearch = async (values = formSearch.getFieldsValue()) => {
        try {
            setLoading(true)
            const res = await inventoryApi.getByMonth({
                ...values,
                month: moment(values.month).format('YYYY-MM')
            })
            setInventoryInfo(res)
        } catch (error) {

        } finally {
            setLoading(false)
        }
    }

    const fetchHoliday = async () => {
        const { holidays } = await holidayApi.getAll()
        setListHoliday(holidays)
    }

    useEffect(() => {
        getStore()
        fetchHoliday()
    }, [])

    return (
        <>
            {contextHolder}
            <div className={cx("title")}>
                <p>{t('inventory')}</p>
                {
                    rolesExportMonthly.includes(+getUser().role) && <ModalMonthlyExport />
                }
            </div>
            <InventoryFilter form={formSearch} shops={shops} onFinish={onSearch} loading={loading} />
            {
                inventoryInfo &&
                <InventoryTable
                    shop={formSearch.getFieldValue('shop')}
                    shopInfo={shopInfo}
                    notify={openNotificationWithIcon}
                    listHoliday={listHoliday}
                    inventoryInfo={inventoryInfo}
                    onSearch={onSearch}
                    month={moment(formSearch.getFieldValue('month')).format('YYYY-MM')} />
            }
        </>
    )
}